import { useLayoutEffect } from 'react'

/**
 * Who draws the chrome on a remote's routes (`/org/:slug/*`, its `/manage`).
 *
 * The app shell hides its own nav, sidebar and footer on those routes from the
 * very first render, because the remote draws its own. It used to be the other
 * way round — shell first, then the remote's layout hid it from an effect once
 * the chunk and the org had both loaded — so a direct link flashed the Carousel
 * nav, two different "Loading..." states, then the org nav.
 *
 * A remote that can't draw its chrome (org not found, no access, a crash) calls
 * `useShellFallback` to get the app shell back, so the visitor isn't stranded
 * on a page with no navigation at all.
 */
const SHELL_FALLBACK_CLASS = 'remote-fallback'

export function useShellFallback() {
  // Before paint, so the error page never shows a frame without navigation.
  useLayoutEffect(() => {
    document.body.classList.add(SHELL_FALLBACK_CLASS)
    return () => document.body.classList.remove(SHELL_FALLBACK_CLASS)
  }, [])
}
